export default __webpack_public_path__ + "static/media/Leave banner.0380d926.png";